export const translations = {
	home: {
		h2_hero: {
			en: "Pleasure, Comfort & Safety",
			fr: "Plaisir, Confort et Sécurité",
		},
		h3_hero: {
			en: "The winning trio of our cars",
			fr: "Le trio gagnant de nos voitures",
		},
		btn_become_dealer: {
			en: "BECOME A DEALER",
			fr: "DEVENIR UN REVENDEUR",
		},
		btn_find_dealer: {
			en: "FIND A DEALER",
			fr: "TROUVER UN REVENDEUR",
		},
		title_our_series:{
			en: "OUR SERIES",
			fr: "NOS SÉRIES",
		},
		btn_learn_more: {
			en: "LEARN MORE",
            fr: "EN SAVOIR PLUS",
		},	
		title_evolution_card: {
			en: "EVOLUTION SERIES",
			fr: "SÉRIE ÉVOLUTION",
		},
		t1_evolution_card: {
			en: "BATTERY LITHIUM",
			fr: "BATTERIE LITHIUM",
		},
		p1_evolution_card: {
			en: "48 Volt 160 Amp",
			fr: "48 Volt 160 Amp",
		},
		t2_evolution_card: {
			en: "ENGINE",
			fr: "MOTEUR",
		},
		p2_evolution_card: {
			en: "6300 Watt",
			fr: "6300 Watt",
		},
		t3_evolution_card: {
			en: "TOUCHSCREEN",
			fr: "ÉCRAN TACTILE",
		},
		p3_evolution_card: {
			en: "Carplay/Android",
			fr: "Carplay/Android",
		},
		t4_evolution_card: {
			en: "MAX SPEED",
			fr: "VITESSE MAX",
		},
		p4_evolution_card: {
			en: "40 Km/h",
			fr: "40 Km/h",
		},
		title_luxor_card: {
			en: "LUXOR SERIES",
			fr: "SÉRIE LUXOR",
		},
		t1_luxor_card: {
			en: "BATTERY LITHIUM",
			fr: "BATTERIE LITHIUM",
		},
		p1_luxor_card: {
			en: "48 Volt 110 Amp",
			fr: "48 Volt 110 Amp",
		},
		t2_luxor_card: {
			en: "ENGINE",
			fr: "MOTEUR",
		},
		p2_luxor_card: {
			en: "6300 Watt",
			fr: "6300 Watt",
		},
		t3_luxor_card: {
			en: "TOUCHSCREEN",
			fr: "ÉCRAN TACTILE",
		},
		p3_luxor_card: {
			en: "Carplay/Android",
			fr: "Carplay/Android",
		},
		t4_luxor_card: {
			en: "MAX SPEED",
			fr: "VITESSE MAX",
		},
		p4_luxor_card: {
			en: "40 Km/h",
			fr: "40 Km/h",
		},
		title_classic_card: {
			en: "CLASSIC SERIES",
			fr: "SÉRIE CLASSIC",
		},
		t1_classic_card: {
			en: "BATTERY LITHIUM",
			fr: "BATTERIE LITHIUM",
		},
		p1_classic_card: {
			en: "48 Volt 110 Amp",
			fr: "48 Volt 110 Amp",
		},
		t2_classic_card: {
			en: "ENGINE",
			fr: "MOTEUR",
		},
		p2_classic_card: {
			en: "6300 Watt",
			fr: "6300 Watt",
		},
		t3_classic_card: {
			en: "TOUCHSCREEN",
			fr: "ÉCRAN TACTILE",
		},
		p3_classic_card: {
			en: "Back up Camera",
			fr: "Caméra de recul",
		},
		t4_classic_card: {
			en: "MAX SPEED",
			fr: "VITESSE MAX",
		},
		p4_classic_card: {
			en: "40 Km/h",
			fr: "40 Km/h",
		},
		title_thor_card: {
			en: "THOR SERIES",
			fr: "SÉRIE THOR",
		},
		t1_thor_card: {
			en: "BATTERY LITHIUM",
			fr: "BATTERIE LITHIUM",
		},
		p1_thor_card: {
			en: "48 Volt 110 Amp",
			fr: "48 Volt 110 Amp",
		},
		t2_thor_card: {
			en: "ENGINE",
			fr: "MOTEUR",
		},
		p2_thor_card: {
			en: "6300 Watt",
			fr: "6300 Watt",
		},
		t3_thor_card: {
			en: "TOUCHSCREEN",
			fr: "ÉCRAN TACTILE",
		},
		p3_thor_card: {
			en: "Back up Camera",
			fr: "Caméra de recul",
		},
		t4_thor_card: {
			en: "MAX SPEED",
			fr: "VITESSE MAX",
		},
		p4_thor_card: {
			en: "40 Km/h",
			fr: "40 Km/h",
		},
		title_diablo_card: {
			en: "DIABLO SERIES",
			fr: "SÉRIE DIABLO",
		},
		t1_diablo_card: {
			en: "ACID BATTERY",
			fr: "BATTERIE ACIDE",
		},
		p1_diablo_card: {
			en: "(6 x 8V) 48V",
			fr: "(6 x 8V) 48V",
		},
		t2_diablo_card: {
			en: "ENGINE",
			fr: "MOTEUR",
		},
		p2_diablo_card: {
			en: "4000 Watt",
			fr: "4000 Watt",
		},
		t3_diablo_card: {
			en: "TOUCHSCREEN",
			fr: "ÉCRAN TACTILE",
		},
		p3_diablo_card: {
			en: "Back up Camera",
			fr: "Caméra de recul",
		},
		t4_diablo_card: {
			en: "MAX SPEED",
			fr: "VITESSE MAX",
		},
		p4_diablo_card: {
			en: "30 Km/h",
			fr: "30 Km/h",
		},
		title_tora_card: {
			en: "TORA SERIES",
			fr: "SÉRIE TORA",
		},
		title_new_card: {
			en: "NEW SERIES",
			fr: "NOUVELLE SÉRIE",
		},
		t1_new_card: {
			en: "BATTERY LITHIUM",
			fr: "BATTERIE LITHIUM",
		},
		p1_new_card: {
			en: "48 Volt 110 Amp",
			fr: "48 Volt 110 Amp",
		},
		t2_new_card: {
			en: "ENGINE",
			fr: "MOTEUR",
		},
		p2_new_card: {
			en: "6300 Watt",
			fr: "6300 Watt",
		},
		t3_new_card: {
			en: "TOUCHSCREEN",
			fr: "ÉCRAN TACTILE",
		},
		p3_new_card: {
			en: "Back up Camera",
			fr: "Caméra de recul",
		},
		t4_new_card: {
			en: "MAX SPEED",
			fr: "VITESSE MAX",
		},
		p4_new_card: {
			en: "40 Km/h",
			fr: "40 Km/h",
		},
		about_title: {
			en: "ELECTRIQUE VALLEY",
			fr: "ELECTRIQUE VALLEY",
		},
		p_about: {	
			en: "Electrique Valley is a Quebec-based company specializing in the design and manufacture of electric vehicles. Our mission is to offer our customers...Here you will find a wide selection of carts offering style, performance and comfort. Our vehicles are specially designed to meet the needs of urban drivers, but also adventure enthusiasts who want to explore new roads.",			
			fr: "Electrique Valley est une entreprise québécoise spécialisée dans la conception et la fabrication de véhicules électriques. Notre mission est d'offrir à nos clients...Chez nous, vous trouverez une large sélection de voiturettes offrant style, performance et confort. Nos véhicules sont spécialement conçus pour répondre aux besoins des conducteurs urbains, mais aussi aux amateurs d'aventure qui souhaitent explorer de nouvelles routes.",
		},
		title_paint1: {
			en: "PPG Metallic",
			fr: "Peinture de Carrosserie",
		},
		title_paint2: {
			en: "Premium Body Paint",
			fr: "Premium PPG Metallic",
		},
		p_paint: {
			en: "*Please note that due to variations between monitors, actual colors may vary. Check with your dealer for actual colors. We reserve the right to make corrections, modifications and improvements to the product at any time without notice.",
			fr: "*Veuillez noter qu'en raison des variations entre les écrans, les couleurs réelles peut varier. Vérifiez auprès de votre revendeur les couleurs réelles. Nous nous réservons le droits d'apporter des corrections ainsi que des modifications et améliorations du produit à tout moment sans préavis.",
		},
		title_features: {
			en: "FEATURES",
			fr: "CARACTÉRISTIQUES",
		},
		card1_title_features: {
			en: "PERFORMANCE",
			fr: "PERFORMANCE",
		},
		card1_description_features: {
			en: "Discover our carts combining performance and energy efficiency for an exceptional driving experience.",
			fr: "Découvrez nos voiturettes alliant performance et efficacité énergétique pour une expérience de conduite exceptionnelle.",
		},
		card2_title_features: {
			en: "SECURITY",
			fr: "SÉCURITÉ",
		},
		card2_description_features: {
			en: "Safety first - discover our carts designed to offer a safe and protected driving experience on all roads. At Electrique Valley, safety is our top priority.",
			fr: "Sécurité avant tout - découvrez nos voiturettes concues pour offrir une expérience de conduite sure et protégée sur tout les routes .Chez Electrique valley, la sécurité est notre priorité absolue.",
		},
		card3_title_features: {
			en: "TECHNOLOGY",
			fr: "TECHNOLOGIE",
		},		
		card3_description_features: {
			en: "Our carts are equipped with the latest technological advances to offer cutting-edge functionality.",
			fr: "Nos voiturettes sont équipées des dernieres avancées technologie pour offrir des fonctionnalités de pointe .",	
		},
		card4_title_features: {
			en: "LUXURY",
			fr: "LUXE",
		},
		card4_description_features: {
			en: "Our luxury carts are carefully designed to meet the most demanding expectations. Every detail is meticulously thought out, from the refined lines of the bodywork to the high-quality materials used in the cabin.",
			fr: "Nos voiturette de luxe sont concues avec soin pour répondre aux attentes les plus exigeants . Chaque détail est méticuleusement pensé, des lignes raffinées de la carrosserie aux matériaux de haute qualité utilisés dans l'habitacle.",
		},
		card5_title_features: {
			en: "COMFORT",
			fr: "CONFORT",
		},
		card5_description_features: {
			en: "Our carts offer exceptional comfort for a pleasant drive. Every detail has been carefully designed to ensure passengers can enjoy a comfortable ride.",
			fr: "Nos voiturette offrent un confort exceptionnel pour une conduite agréable . Chaque détail a été soigneusement concu pour garantir que les passagers puissent profiter d'un trajet confortable.",
		},
		card6_title_features: {
			en: "AESTHETIC",
			fr: "ESTHÉTIQUE",
		},
		card6_description_features: {
			en: "Our carts are distinguished by their elegant and attractive aesthetic. Every detail has been carefully considered to create an aesthetically pleasing and modern appearance.",
			fr: "Nos voiturettes se distinguent par leur esthétique élégante et attrayante.Chaque détail a été soigneusement pensé pour créer une apparence esthétiquement agréable et moderne.",
		},
		title_warranty: {
			en: "1 YEAR WARRANTY",
			fr: "GARANTIE 1 AN",
		},	
		subtitle_warranty: {
			en: "Our Commitment to Quality",
			fr: "Notre Engagement envers la Qualité",
		},
		p_warranty: {
			en: "For us, the satisfaction of our customers is essential, we are proud to offer you a complete guarantee to ensure the reliability and durability of your cart, the battery is guaranteed for 1 year. Please note that the warranty does not cover damage caused by negligent or accidental misuse of the cart.",
			fr: "Chez nous la satisfaction de  nos clients est primordiale nous sommes fiers de vous offrir une garantie complete pour assurer la fiabilité et la durabilité de votre voiturette les batterie garantie 1 ans . Veuillez noter que la garantie ne couvre pas les dommages causés pas une utilisation abusive négligente ou accidentelle de la voiturette",
		},

		title_lithium_battery: {
			en: "LITHIUM",
			fr: "BATTERIE",
		},
		title_lithium_battery_span: {
			en: "BATTERY",
			fr: "LITHIUM",
		},
		p_lithium_battery: {
			en: "Our carts are equipped with a powerful lithium battery that offers a range of up to 60 km. The battery is designed to be recharged quickly and easily, so you can enjoy your cart for longer.",
			fr: "Nos voiturettes sont équipées d'une puissante batterie au lithium qui offre une autonomie allant jusqu'à 60 km. La batterie est conçue pour être rechargée rapidement et facilement, afin que vous puissiez profiter de votre voiturette plus longtemps.",
		},
		li1_lithium_battery: {
			en: "8 YEARS WARRANTY",
			fr: "8 ANS DE GARANTIE",
		},
		li2_lithium_battery: {
			en: "NO MAINTEINANCE",
			fr: "PAS D'ENTRETIEN",
		},

		title_register_become_dealer: {
			en: "REGISTER TO BECOME A DEALER",
			fr: "INSCRIVEZ-VOUS POUR DEVENIR REVENDEUR",
		},
		subtitle_register_become_dealer: {
			en: "We are looking for new official resellers who trust our products and who put professionalism as a differentiating virtue.",
			fr: "Nous recherchons de nouveaux revendeurs officiels qui font confiance à nos produits et qui mettent le professionnalisme comme vertu différenciatrice.",
		},
		btn_register_dealer: {
			en: "REGISTER TO BECOME DEALER",
			fr: "INSCRIVEZ-VOUS POUR DEVENIR REVENDEUR",
		},
		h2_videoShowcase: {
			en: "VIDEO SHOWCASE",
            fr: "VITRINE VIDÉO",
		},
		btn_videoShowcase: {
			en: "WATCH MORE...",
			fr: "REGARDER PLUS...",
		},
		title_test_ride: {
			en: "READY FOR A TEST RIDE?",
			fr: "PRÊT POUR UN ESSAI?",
		},
		p_test_ride: {
			en: "Contact us now to schedule a test drive or to get more information. We look forward to helping you purchase your new dream cart!",
			fr: "Contactez-nous dès maintenant  pour  planifier un essai routier ou pour obtenir des informations supplémentaires. Nous sommes impatients de vous  accompagner dans l'achat de votre nouvelle voiturette de rêve!",	
		},
		btn_test_ride: {
			en: "CONTACT US",
			fr: "CONTACTEZ-NOUS",
		},
		title_signup: {
			en: "Subscribe to our newsletter",
			fr: "Abonnez-vous à notre infolettre",
		},
		btn_signup: {
			en: "SUBSCRIBE",
			fr: "S'ABONNER",
		},
		p_sighup: {
			en: "We value your privacy. We will never spam you or pass your information on to third parties.",
			fr: "Nous respectons votre vie privée. Nous ne vous enverrons jamais de spam ni ne transmettrons vos informations à des tiers.",	
		},
	}
} as const;
  
type TranslationKeys = typeof translations.home.h2_hero;
export type Language = keyof TranslationKeys;
